import locale from 'date-fns/locale/fr';
import { parseISO, format } from 'date-fns';
import { upperFirst } from 'lodash';

const formatDate = (date, formatStr) => {
  if (!date) {
    return '';
  }

  if (formatStr == null) {
    formatStr = 'dd/MM/yyyy';
  }
  let formatDate = date;
  if (date !== null) {
    if (typeof date === 'string') {
      date = parseISO(date);
    }
    formatDate = format(date, formatStr, { locale });
    formatDate = upperFirst(formatDate);
  }
  return formatDate;
};

export default {
  formatDate
};
